import React, { useState } from 'react';

export default function BulkUserForm({ onSave, onCancel }) {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Parse textarea: email,firstName,lastName per line or comma delimited
    const lines = value.split(/\n|,/).map(l => l.trim()).filter(Boolean);
    const users = [];
    for (let i = 0; i < lines.length; i += 3) {
      if (lines[i] && lines[i+1] && lines[i+2]) {
        users.push({ email: lines[i].trim(), firstName: lines[i+1].trim(), lastName: lines[i+2].trim() });
      } else {
        setError(`Incomplete entry at row ${Math.floor(i / 3) + 1}: each user needs email, firstName, lastName.`);
        return;
      }
    }
    setError('');
    onSave(users);
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 400 }}>
      <h3>Add Users in Bulk</h3>
      <div>
        <label>Paste comma-delimited list (email,firstName,lastName per user, separated by commas or newlines):<br />
          <textarea value={value} onChange={e => setValue(e.target.value)} rows={6} style={{ width: '100%' }} required />
        </label>
      </div>
      {error && <div style={{ color: 'red' }}>{error}</div>}
      <div style={{ marginTop: 12 }}>
        <button type="submit" className="button-primary">Add Users</button>
        <button type="button" onClick={onCancel} style={{ marginLeft: 8 }} className="button-default">Cancel</button>
      </div>
    </form>
  );
}
